'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*jshint esversion: 6 */

// A class to remove things from the screen
var hide = function () {
	function hide() {
		_classCallCheck(this, hide);
	}

	_createClass(hide, [{
		key: 'dropDowns',
		value: function dropDowns() {
			var open = document.getElementsByClassName('open');
			var openArray = Array.prototype.slice.call(open);

			var faded = document.getElementsByClassName('faded');
			var fadedArray = Array.prototype.slice.call(faded);

			var active = jQuery('.is-active').not('.toolbar-tray').not('.mission-nav.subnav-stick a');

			// openArray.forEach(function(item){
			// 	item.classList.remove('open');
			// });

			openArray.forEach(function (item) {
				//item.classList.remove('open');
				if (!item.classList.contains('flatpickr-calendar')) {
					item.classList.remove('open');
				}
			});

			fadedArray.forEach(function (item) {
				item.classList.remove('faded');
			});

			jQuery('.page-header').removeClass('focused');

			jQuery(active).removeClass('is-active');
		}
		// secondaryNav() {
		// 	let drop = document.getElementsByClassName('drop');
		// 	let dropArray = Array.prototype.slice.call(drop);
		//
		// 	if(dropArray.length) {
		// 		dropArray.forEach(function(dropped){
		// 			dropped.classList.remove('drop');
		// 		});
		// 	}
		// }

	}, {
		key: 'fade',
		value: function fade() {
			jQuery('.faded').removeClass('faded');
		}
	}, {
		key: 'booking',
		value: function booking() {
			jQuery('.check-rates').hide();
		}
	}, {
		key: 'secondaryMenus',
		value: function secondaryMenus(skip) {
			var callMenu = jQuery('nav.call-menu');
			var callDropDown = jQuery('nav.call-menu .sub-menu');
			var missionDropDown = jQuery('.js-mission-menu');
			var missionMenu = jQuery('.js-mission');
			var appDownloadMenu = jQuery('.js-util-app-download');
			var appDownloadDropDown = jQuery('.js-app-download-menu');
			var translateMenuNew = jQuery('nav.top-nav-translation');
			var translateMenuNewDropdown = jQuery('nav.top-nav-translation .sub-menu');
			var transDrop = jQuery('.translation-links');

			if (callMenu.hasClass('show') && skip !== "noCallMenu") {
				callDropDown.toggle();
				callMenu.removeClass('show');

				if (callMenu.attr('aria-expanded') === 'false') {
					callMenu.attr('aria-expanded', 'true');
				} else {
					callMenu.attr('aria-expanded', 'false');
				}
				if (callDropDown.attr('aria-hidden') === 'true') {
					callDropDown.attr('aria-hidden', 'false');
				} else {
					callDropDown.attr('aria-hidden', 'true');
				}
			}

			if (missionMenu.hasClass('show') && skip !== "noMissionMenu") {
				missionDropDown.toggle();
				missionMenu.removeClass('show');

				if (missionMenu.attr('aria-expanded') === 'false') {
					missionMenu.attr('aria-expanded', 'true');
				} else {
					missionMenu.attr('aria-expanded', 'false');
				}
				if (missionDropDown.attr('aria-hidden') === 'true') {
					missionDropDown.attr('aria-hidden', 'false');
				} else {
					missionDropDown.attr('aria-hidden', 'true');
				}
			}

			if (appDownloadMenu.hasClass('show') && skip !== "noAppDownloadMenu") {
				appDownloadDropDown.toggleClass('app-download-menu-hidden');
				appDownloadMenu.removeClass('show');

				if (appDownloadMenu.attr('aria-expanded') === 'false') {
					appDownloadMenu.attr('aria-expanded', 'true');
				} else {
					appDownloadMenu.attr('aria-expanded', 'false');
				}

				if (appDownloadDropDown.attr('aria-hidden') === 'true') {
					appDownloadDropDown.attr('aria-hidden', 'false');
				} else {
					appDownloadDropDown.attr('aria-hidden', 'true');
				}
			}

			if (translateMenuNew.hasClass('show') && skip !== "noLangMenu") {
				translateMenuNewDropdown.toggle();
				translateMenuNew.removeClass('show');

				if (translateMenuNew.attr('aria-expanded') === 'false') {
					translateMenuNew.attr('aria-expanded', 'true');
				} else {
					translateMenuNew.attr('aria-expanded', 'false');
				}
				if (translateMenuNewDropdown.attr('aria-hidden') === 'true') {
					translateMenuNewDropdown.attr('aria-hidden', 'false');
				} else {
					translateMenuNewDropdown.attr('aria-hidden', 'true');
				}
			}

			// transDrop.select2("close");
		}
	}, {
		key: 'mobileMenu',
		value: function mobileMenu() {
			var mainHeader = jQuery('header[role="banner"]');
			jQuery('.menu-toggle').attr('aria-expanded', 'false').removeClass('is-active');
			jQuery('.navigation-mobile-wrapper').removeClass('show');
			jQuery(mainHeader).removeClass('mobile-open');
			jQuery('body').toggleClass('scroll-lock');

			//removing class on header that makes it white when mobile menu is open
			//added a debouncer to only fire function when user has stopped resizing
			var resizeTimer;

			jQuery(window).on('resize', function (e) {
				clearTimeout(resizeTimer);
				resizeTimer = setTimeout(function () {
					if (jQuery(window).width() >= 1110) {
						if (jQuery(mainHeader).hasClass('mobile-open')) {
							jQuery(mainHeader).removeClass('mobile-open');
						}
					}
				}, 250);
			});

			mainHeader.removeClass('focused');
		}
	}, {
		key: 'callUs',
		value: function callUs() {
			var callUsMenu;
			callUsMenu = jQuery('.hotel-phone-list');
			if (callUsMenu.hasClass('show')) {
				callUsMenu.removeClass('show');
			}
		}
	}, {
		key: 'all',
		value: function all() {
			this.dropDowns();
			this.booking();
			this.mobileMenu();
			this.secondaryMenus();
		}
	}]);

	return hide;
}();
// Invoke the class so we can use it


var clearScreen = new hide();

// accepts a standard date string (2020-10 or 2020-10-01) and converts it to a user friendly format..
function dateToString(date) {
	var count = (date.match(/-/g) || []).length;
	if (count == 1) {
		date = date + '-01'; // append the day value..
	}
	var d = new Date(date);
	var strArray = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
	var day = d.getUTCDate() + 1;
	// @todo: figure out why I need to do this..
	var month = strArray[d.getUTCMonth()];
	var year = d.getUTCFullYear();
	var string = count == 1 ? month + ', ' + year : month + ' ' + day + ', ' + year;
	return string;
}

function unsetHeight(selectors) {
	// Convert the selectors to an array if they're returned as a NodeList.
	if (!selectors.isArray) {
		selectors = Array.prototype.slice.call(selectors);
	}

	if (selectors.length !== 0) {
		selectors.forEach(function (item) {
			item.style.height = 'auto';
		});
	}
}

function setRowSize(sm, md, lg, xl, xxl) {
	var rowSize = sm;

	if (jQuery(window).width() >= 767) {
		rowSize = md;
	}
	if (jQuery(window).width() >= 1280) {
		rowSize = lg;
	}
	if (jQuery(window).width() >= 1440) {
		rowSize = xl;
	}
	if (jQuery(window).width() >= 1920) {
		rowSize = xxl;
	}
	return rowSize;
}

(function ($) {
	$('.translation-links').select2({
		minimumResultsForSearch: -1,
		dropdownCssClass: 'notranslate language-dropdown',
		width: "100vw"
	});
})(jQuery);

(function ($) {

	setTimeout(function () {
		var googleTranslateElem = document.querySelector('.goog-te-gadget-simple');
		googleTranslateElem.setAttribute('aria-label', 'Translate this page');
	}, 5000);
})(jQuery);

function formatDate(date) {
	var d = void 0;

	/* if (typeof date === 'undefined') {
   d = new Date();
 } else { */
	d = new Date(date);
	/* } */
	var month = '' + (d.getMonth() + 1),
	    day = '' + d.getDate(),
	    year = d.getFullYear();

	if (month.length < 2) month = '0' + month;
	if (day.length < 2) day = '0' + day;

	return [year, month, day].join('-');
}

function monthFormatDate(date) {

	var d = void 0;
	/* if (typeof date === 'undefined') {
   d = new Date();
 } else { */
	d = new Date(date);
	/* } */
	var month = '' + (d.getMonth() + 1),
	    year = d.getFullYear();

	if (month.length < 2) month = '0' + month;

	return [year, month].join('-');
}

(function ($) {

	// Wrap pro-nouns in <span class="notranslate"> to prevent google from attempting to translate them
	var brandStrings = ["Baccarat Boutique", "Espirit De Baccarat", "Baccarat Hotels", "Baccarat Hotel", "Baccarat", "Grand Salon", "The Bar", "Gilles Barbier", "Bardula", "Vincent Fournier", "Marianne Guely", "Francois Houtin & Bénédicte Mongrolle", "Armand Jonckers", "Eva Jospin", "Mathieu Mercier", "Cecile Meynier", "Ludovic Sauvage", "Jean-Luc Bourgougnon", "Frédéric Furst", "Raymond Regnault", "Philippe Vernier", "Michel Barge", "René Vinter", "Skidmore, Owings & Merrill", "Sh Hotels & Resorts", "Gilles & Boissier", "Starwood Capital Group", "Tribeca Associates"];
	//   $.each(brandStrings, function (index, value) {

	//     $("body *").html(function (_, text) {
	//       var regex = new RegExp(value, 'g');
	//       if (!this.children.length) {
	//         return text.replace(regex, '<span class="notranslate">' + value + '</span>');
	//       }
	//     });

	//   });

	//Wrapped in a function so they can be timedout to be able to attach titles to the owl carousel items
	function setButtonTitles() {
		var previous = document.querySelectorAll('.owl-prev');
		var next = document.querySelectorAll('.owl-next');
		var dots = $('.owl-dots:not(.disabled)');
		for (var i = 0; i < previous.length; i++) {
			previous[i].title = "Previous";
			next[i].title = "Next";
		}
		dots.each(function () {
			var i = 0;
			$(this).find('.owl-dot').each(function () {
				i++;
				$(this).attr('aria-label', "Slide " + i);
			});
		});
	}
	setTimeout(setButtonTitles, 500);
})(jQuery);

(function ($) {
	// Open the booking Widget
	// var checkRatesWidget;
	// checkRatesWidget = $('.check-rates');

	// $('.js-book').on('click', function(){
	// 	if(window.innerWidth <= 768) {
	// 		$(window).scrollTop(0);
	// 	}
	// 	checkRatesWidget.show();
	// 	return false;
	// });

	//===================================================
	// Hack to prevent :fixed button clicks scrolling the bottom nav into view on Safari mobile
	// https://stackoverflow.com/questions/60804268/how-to-know-when-bottom-nav-bar-is-visible-in-mobile-safari
	var initial = 0;
	var animateHeader = false;

	var ua = window.navigator.userAgent;
	var iOS = !!ua.match(/iPad/i) || !!ua.match(/iPhone/i);
	var webkit = !!ua.match(/WebKit/i);
	//check if using mobile safari [returns true is mobile safari] =====
	var iOSSafari = iOS && webkit && !ua.match(/CriOS/i);

	//this is where the magic happens=====================

	if (iOSSafari) {
		initial = $(window).height();
		$(window).resize(function () {
			if ($(window).height() >= initial && animateHeader === false) {
				$("header").animate({ marginBottom: "60px" });
				animateHeader = true;
			} else {
				$("header").animate({ marginBottom: "2%" }, function () {
					animateHeader = false;
				});
			}
		});
	}
	//===================================================
})(jQuery, Drupal);

// Header Toggle
(function ($) {
	$('.faq--header-toggle').click(function (e) {

		if ($(this).data('closesiblings')) {
			$(".faq--header-toggle").not(this).removeClass('active').attr("aria-expanded", false);
			$(".faq--header-toggle").not(this).siblings('.faq--wrapper').slideUp();
		}

		$(".faq--question").removeClass('active').attr("aria-expanded", false);
		$('.faq--answer-wrapper').slideUp();

		$(this).toggleClass('active');
		$(this).siblings('.faq--wrapper').slideToggle();

		if ($(this).hasClass('active')) {
			$(this).attr("aria-expanded", true);
		} else {
			$(this).attr("aria-expanded", false);
		}
	});
})(jQuery);

// FAQ Toggle
(function ($) {
	$('.faq--question').click(function (e) {
		e.stopPropagation();

		if ($(this).data('closesiblings')) {
			$(".faq--question").not(e.target).removeClass('active').attr("aria-expanded", false);
			$(".faq--question").not(e.target).siblings('.faq--answer-wrapper').slideUp();
		}

		$(this).toggleClass('active');
		$(this).siblings('.faq--answer-wrapper').slideToggle();

		if ($(this).hasClass('active')) {
			$(this).attr("aria-expanded", true);
		} else {
			$(this).attr("aria-expanded", false);
		}
	});
})(jQuery);

// Social Sharing
(function ($) {
	var shareLinks;
	shareLinks = $('.sharebar ul li a');

	if (shareLinks.length) {
		shareLinks.each(function () {
			var shareBar, shareUrl, popAttributes;
			shareBar = $('.sharebar');
			popAttributes = "width=600, height=400, scrollbars=no";
			shareUrl = $(this).closest(shareBar).data('shareurl');

			$(this).on('click', function () {
				if ($(this).data('facebook') && shareUrl.length) {
					window.open($(this).data('facebook') + shareUrl, "pop", popAttributes);
				} else if ($(this).data('twitter') && shareUrl.length) {
					window.open($(this).data('twitter') + shareUrl, "pop", popAttributes);
				} else if ($(this).data('toggle') === 'popover' && shareUrl.length) {
					$(this).on('shown.bs.popover', function () {
						$(this).find('.popover input').select();
						document.execCommand("copy");
						if (document.execCommand("copy") && !$(this).find('.popover-body div').length) {
							$(this).find('.popover-body').append('<div class="alert alert-success" role="alert">Link copied to clipboard</div>');
						}
					});
				}
			});
			if ($(this).data('toggle') === 'popover') {
				$(this).popover({
					// trigger: 'focus',
					container: $(this)
				});
			}
		});
	}
})(jQuery);

(function ($) {
	var clearAllButton = $('.filter-clear-all');
	var url = window.location.href;

	if (clearAllButton.length) {
		clearAllButton.onclick(function () {
			window.history.pushState("object or string", "Title", url.split("?")[0]);
			$(document).ajaxStop(function () {
				$(this).click();
			});
		});
	}
})(jQuery);

// for the news articles view block, fire a new AJAX request when the category selection is changed
(function ($, Drupal) {
	Drupal.behaviors.initNewsArticlesExposedFilters = {
		attach: function attach(context, settings) {
			var form, select, submit;
			form = $('form#views-exposed-form-news-articles-block-1');
			select = form.find('select[data-drupal-selector="edit-tid"]');
			submit = form.find('input.form-submit');
			select.on('change', function () {
				submit.trigger('click');
			});
		}
	};
})(jQuery, Drupal);

var notifyBar = jQuery('.notify-bar--block');
var $region_highlighted = jQuery('.region-highlighted');
var notifyBarHeight;

jQuery(window).on('load', function () {
	objectFitVideos();

	var notifyBarCookie = Cookies.get('highlighted-region-active');

	notifyBarHeight = notifyBar.innerHeight();

	if ($region_highlighted.length && !notifyBarCookie) {
		$region_highlighted.addClass('highlighted-region-active');
		jQuery(".page-header").addClass('highlighted-region-active');
		jQuery(".page-header").css('top', notifyBarHeight);
		Cookies.set('highlighted-region-active', '1');
	}
});

var resizeTimer;

jQuery(window).on('resize', function (e) {

	clearTimeout(resizeTimer);
	resizeTimer = setTimeout(function () {
		notifyBarHeight = notifyBar.innerHeight();

		if ($region_highlighted.hasClass('highlighted-region-active')) {
			jQuery(".page-header").css('top', notifyBarHeight);
		}
	}, 250);
});

// document.body.innerHTML += "<div id='edit-be-the-first-to-find-out-everything-about-1-hotels--description' class='d-none'></div>";

(function ($) {
	var $coll = $('#js-room-ada');

	$coll.click(function () {
		$coll.toggleClass('active');
		$coll.next().toggleClass('hidden');
	});
})(jQuery);

// (function($){
//   var $learnMore = $('.js-learn-more');

//   $learnMore.click(function(){
//     $(this).siblings('.js-learn-more--trimmed-description').toggleClass('hidden');
//     $(this).siblings('.js-learn-more--full-description').toggleClass('hidden');

//     if($(this).text() === 'Read More'){
//       $(this).text('Read Less');
//       $(this).toggleClass('read-less');
//     } else {
//       $(this).text('Read More');
//       $(this).toggleClass('read-less');
//     }
//   });
// }(jQuery));

// Hotel Room Listing Modal
(function ($) {
	Drupal.behaviors.initHotelRoomsModal = {
		attach: function attach(context, settings) {
			var modalData = void 0;
			var hotelListingsModal = $('#hotel-rooms-view-modal');
			var galleryModal = $('.card--hotel-room .gallery-modal');
			var cardImgCarousel = $('.card--hotel-room header .owl-carousel.img-carousel');
			var carouselOpts = {
				items: 1,
				nav: true,
				loop: true,
				dots: false
			};

			var cardImgOpts = {
				items: 1,
				nav: true,
				rewind: false,
				dots: false,
				smartSpeed: 1000
			};

			cardImgCarousel.owlCarousel(cardImgOpts);

			$('.header-buttons', context).once('initHotelRoomsModal').on('click', ' .btn', function (e) {
				var $this = $(this);

				if ($this.data('floorplan')) {
					modalData = "<img src='" + $this.data('floorplan') + "' alt='modal floorplan image'/>";
					hotelListingsModal.addClass('floorplan-modal');
				} else if ($this.data('tour')) {
					modalData = $this.data('tour');
					hotelListingsModal.addClass('tour-modal');
				}

				hotelListingsModal.find('.modal-body').html(modalData);
			});

			galleryModal.on('show.bs.modal', function () {
				if ($(this).has('.owl-carousel')) {
					$(this).find('.owl-carousel').owlCarousel(cardImgOpts);
				}
			});

			galleryModal.on('shown.bs.modal', function () {
				var modalCloseBtn = $(this).find('.close');
				modalCloseBtn.focus();

				// ADA - when a modal carousel is open, allow user to navigate through carousel with left/right arrow keys instead of tabbing to arrow BUTTONS and pressing enter on them
				$(document).once().on('keyup', function (event) {
					var thisModalCarousel = $('.card--hotel-room .gallery-modal .owl-carousel');
					var leftArrowKey = 37;
					var rightArrowKey = 39;
					var pressedKey = event.keyCode;
					if (pressedKey == leftArrowKey) {
						thisModalCarousel.trigger('prev.owl.carousel');
					}
					if (pressedKey == rightArrowKey) {
						thisModalCarousel.trigger('next.owl.carousel');
					}
				});
			});

			hotelListingsModal.on('hide.bs.modal', function () {
				hotelListingsModal.removeClass('gallery-modal floorplan-modal tour-modal');
				hotelListingsModal.find('.modal-body').empty();
			});
		}
	};
})(jQuery);

(function ($) {
	// var headerEl = $('.layout-container header');

	// headerEl.hover(function(){
	// 	if ($(window).width() > 1280)
	// 		$(this).toggleClass('focused');
	// });

	// headerEl.hover(
	// 	function () {
	// 		if ($(window).width() > 1280) {
	// 			$(this).addClass("focused");
	// 		}
	// 	}, function () {
	// 		if ($(window).width() > 1280) {
	// 			$(this).removeClass("focused");
	// 		}
	// 	}
	// );

	$(".notify-bar--block .inner-block a").click(function (e) {
		e.preventDefault();
		$('.region-highlighted').removeClass('highlighted-region-active');
		$(".page-header").removeClass('highlighted-region-active');
		$(".page-header").css('top', '0');

		var url = $(this).attr('href');
		window.open(url, '_blank');
	});

	$(".notify-bar--block .inner-block button").click(function (e) {
		e.preventDefault();
		$('.region-highlighted').removeClass('highlighted-region-active');
		$(".page-header").removeClass('highlighted-region-active');
		$(".page-header").css('top', '0');
	});
})(jQuery);

(function ($) {
	var venuePopupOpen = Array.from(document.getElementsByClassName('popup-trigger'));

	if (venuePopupOpen.length) {
		venuePopupOpen.forEach(function (popup) {
			$(popup).click(function () {
				var popup_id = $(this).attr('data-popup-id');
				var popup_window = document.getElementById(popup_id);
				$(popup_window).css('display', 'flex');

				// add event listener for a click outsde of the popup
				$('.venue-popup').click(function (e) {
					if (e.target.classList == 'venue-popup') {
						$(popup_window).css('display', 'none');
					}
				});

				// mobile, hide scroll arrow if you're at the bottom of the popup element
				var venue_popup = $(popup_window).find('.venue-with-popup')[0];
				var popup_window_height = $(venue_popup).scrollTop() + $(venue_popup).innerHeight() + $(venue_popup).height();
				var popup_scroll_height = venue_popup.scrollHeight + $(venue_popup).height();
				console.log(popup_window_height);
				console.log(popup_scroll_height);
				if ($(window).width() < 1110 && popup_window_height != popup_scroll_height) {
					$('.venue-with-popup').scroll(function () {
						var scroll_article = this;
						var article_window_height = $(scroll_article).scrollTop() + $(scroll_article).innerHeight() + $(scroll_article).height();
						var article_scroll_height = scroll_article.scrollHeight + $(scroll_article).height();
						if (article_window_height >= article_scroll_height) {
							$(scroll_article).find('.popup-scroll').css('opacity', '0');
						} else {
							$(scroll_article).find('.popup-scroll').css('opacity', '1');
						}
					});
				} else {
					$(venue_popup).find('.popup-scroll').css('display', 'none');
				}
			});
		});
	}

	var venuePopupClose = Array.from(document.getElementsByClassName('popup-close'));

	if (venuePopupClose.length) {
		venuePopupClose.forEach(function (popup) {
			$(popup).click(function () {
				var popup_id = $($(this).parent().parent()).attr('id');
				var popup_window = document.getElementById(popup_id);
				$(popup_window).css('display', 'none');
			});
		});
	}
})(jQuery);

// Add toggle for venue chart on table to be like accordion
(function ($, Drupal) {
	var classNameTarget = "hide-all";

	$('.js-show-venue').on('click', function (e) {
		var parent = $(this).parent();
		if (parent.hasClass(classNameTarget)) {
			parent.removeClass(classNameTarget);
			$(this).attr("aria-expanded", true);
		} else {
			parent.addClass(classNameTarget);
			$(this).attr("aria-expanded", false);
		}
	});
})(jQuery, Drupal);

// When the venue chart table gets bigger than parent force it to go into mobile styling
(function ($, Drupal) {

	var venueCharts = document.querySelectorAll('.venue-chart');

	venueCharts.forEach(function (chart) {
		var wrapper = document.querySelector('.venue-chart__inner');
		var table = document.querySelector('.venue-chart__table');

		var savedSize; // The width when the table gets bigger than the parent

		function compareTableWidth() {
			var wrapperWidth = wrapper.clientWidth - 80; // -80 to remove padding
			var tableWidth = table.offsetWidth;

			if (!savedSize && tableWidth > wrapperWidth) {
				chart.classList.add('setMobile');
				savedSize = tableWidth;
			} else if (savedSize && wrapperWidth > savedSize) {
				chart.classList.remove('setMobile');
				savedSize = undefined;
			}
		}

		compareTableWidth();
		window.addEventListener('resize', compareTableWidth);
	});
	// Vimeo JS play and pause button
	// vimeo player - hero
	$('.video__controls--play, .video__controls--pause').on('click', function () {
		$('.video__controls button').toggleClass('hide');

		// For ADA tabbing/entering purposes. The below if chain makes sure that the next focused element after an enter press is the opposite button
		// For some reason, without the below if checks, after an enter press, the next focus element is the <body> tag :/
		if ($(this).hasClass("video__controls--pause")) {
			$(this).prev().focus();
		}
		if ($(this).hasClass("video__controls--play")) {
			$(this).next().focus();
		}
	});

	if ($('.vimeo_media .video__wrapper').length) {
		var iframe = $('.vimeo_media iframe')[0];

		// Had to use MutationObserver cause onecookie was messing with Iframes
		var observer = new MutationObserver(function (mutationList, observer) {
			mutationList.forEach(function (mutation) {

				if (Vimeo) {
					var player = new Vimeo.Player(iframe);

					// bind events
					var playButton = $(".video__controls--play")[0];
					playButton.addEventListener("click", function () {
						player.play();
					});

					var pauseButton = $(".video__controls--pause")[0];
					pauseButton.addEventListener("click", function () {
						player.pause();
					});
				}
			});
		});

		observer.observe(iframe, { attributeFilter: ['src'] });
	}

	$('.play-button').on('click', function () {
		$(this).parent('.vimeo_media').find('.video__wrapper').css('z-index', '1');
		var video_id = $(this).parent('.vimeo_media').find('.video__wrapper').attr('data-video-id');
		var iframe = $(this).parent('.vimeo_media').find('iframe');
		if (video_id) {
			$(this).parent('.vimeo_media').addClass('play-video');
			var video_markup = '<iframe src="https://player.vimeo.com/video/' + video_id + '?autoplay=1" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>';
			$(this).parent('.vimeo_media').find('.video__wrapper').html(video_markup);
		} else if (iframe) {
			iframe.attr('src', iframe.attr('src') + '?autoplay=1');
		}
	});
})(jQuery, Drupal);

// Fixing aria label for popup newsletter form description
(function ($, Drupal) {
	var popup_checkbox_description = $('#block-popup .webform-submission-mailchimp-popup-form .form-item-terms-and-conditions .description');
	if ($(popup_checkbox_description).length > 0) {
		$(popup_checkbox_description).attr('id', 'edit-terms-and-conditions--2--description');
	}
})(jQuery, Drupal);

(function ($, Drupal) {

	function isInViewport(el) {
		var rect = el.getBoundingClientRect();
		var extraScreen = 400; // THe Iframe is bigger than the parent page so its still loading

		return rect.top < window.innerHeight && rect.left < window.innerWidth && rect.bottom > 0 - extraScreen && rect.right > 0;
	}

	var VimeoAutoPause = function () {
		function VimeoAutoPause(iframe) {
			_classCallCheck(this, VimeoAutoPause);

			this.type = "vimeo";
			this.iframe = iframe;
			this.vim = new Vimeo.Player(iframe);
			this.autoPaused = false;
		}

		_createClass(VimeoAutoPause, [{
			key: 'ready',
			value: function ready(callback) {
				var self = this;

				self.setup();
				callback();
			}
		}, {
			key: 'setup',
			value: function setup() {
				var self = this;
				this.iframe._autoPause = this; // Set the object in the dom so it can be grabbed later
				this.vim.on('timeupdate', function () {
					if (!document.hasFocus() || !isInViewport(this.iframe)) {
						self.pause();
					}
				});

				window.addEventListener('focus', function () {
					if (isInViewport(self.iframe)) {
						self.play();
					}
				});
			}
		}, {
			key: 'play',
			value: function play() {
				if (this.autoPaused) {
					this.vim.play();
					this.autoPaused = false;
				}
			}
		}, {
			key: 'pause',
			value: function pause() {
				var self = this;
				this.vim.getPaused().then(function (paused) {
					if (!paused) {
						self.vim.pause();
						self.autoPaused = true;
					}
				});
			}
		}]);

		return VimeoAutoPause;
	}();

	Drupal.behaviors.autoPauseVideo = {
		initialized: false,

		attach: function attach(contenxt, settings) {
			if (!this.initialized) {
				this.initialized = true;
				this.init(contenxt, settings);
			}
		},

		init: function init(contenxt, settings) {
			var self = this;
			if (!!window.IntersectionObserver) {
				var iframes = document.querySelectorAll("iframe");
				var players = [];

				iframes.forEach(function (iframe) {

					var observer = new MutationObserver(function (mutationList, observer) {
						//Hoping this will make it easier to have other iframes impletmented in the future
						var player;
						if (iframe.src.match(/player.vimeo\.com/)) {
							player = new VimeoAutoPause(iframe);
						}

						if (player) {
							players.push(player);
							player.ready(function () {
								Interobserver.observe(player.iframe);
							});
						}
					});

					observer.observe(iframe, { attributeFilter: ['src'] });
				});

				var Interobserver = new IntersectionObserver(function (entries, observer) {
					entries.forEach(function (entry) {

						var player = entry.target._autoPause;
						if (!entry.isIntersecting) {
							player.pause();
						} else if (player.autoPaused) {
							player.play();
						}
					});
				}, { threshold: 0 });
			}
		}
	};
})(jQuery, Drupal);

(function ($, Drupal) {
	Drupal.behaviors.preferencesAccordionMobile = {
		attach: function attach(context, settings) {
			// Resolve behavior being called multiple times per page load.
			if (context !== document) {
				return;
			}

			$('.member-preference-question__toggle').once().on('click', function (event) {
				event.preventDefault();
				var clickedButton = $(this);
				var correspondingFieldset = $(this).siblings('fieldset');
				clickedButton.toggleClass('show');
				correspondingFieldset.toggleClass('show');
			});

			$(window).once().on('resize', function () {
				var allFieldsetsArray = $('.member-preference-question__container fieldset');
				var allButtonsArray = $('.member-preference-question__toggle');
				if (window.innerWidth <= 768) {
					allFieldsetsArray.removeClass('show');
					allButtonsArray.removeClass('show');
				}
			});
		}
	};
})(jQuery, Drupal);

(function ($) {
	if ($('body').hasClass('path-member')) {
		setTimeout(function () {
			$('header.page-header').addClass('focused');
		}, 1000);
	}
})(jQuery);

(function ($, Drupal) {
	setTimeout(function () {
		$("img:not([alt])").each(function (index) {
			$(this).attr("alt", "");
		});
	}, 1500);
})(jQuery, Drupal);

(function ($, Drupal) {
	setTimeout(function () {
		$("#edit-terms-conditions-popup").removeAttr("aria-describedby");
	}, 1500);
})(jQuery, Drupal);

(function ($, Drupal) {

	Drupal.behaviors.removeGoogleTagVotingDiv = {
		attach: function attach(context, settings) {
			// Monitor changes in the body.
			var observer = new MutationObserver(function (mutations) {
				mutations.forEach(function (mutation) {
					if (mutation.addedNodes.length) {
						if (Drupal.behaviors.removeGoogleTagVotingDiv.checkAndRemoveDiv(mutation.addedNodes)) {
							observer.disconnect();
						}
					}
				});
			});
			observer.observe(document.body, { childList: true });

			// Initial check.
			if (Drupal.behaviors.removeGoogleTagVotingDiv.checkAndRemoveDiv(document.querySelectorAll('#goog-gt-tt'))) {
				observer.disconnect();
			}
		},
		checkAndRemoveDiv: function checkAndRemoveDiv(nodeList) {
			// Ensure the nodeList is not empty.
			if (nodeList.length === 0) {
				return false;
			}

			nodeList.forEach(function (node) {
				if (node.id === 'goog-gt-tt') {
					node.remove();
					return true;
				}
			});

			return false;
		}
	};
})(jQuery, Drupal);